import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import imgHero from '../img/salto.webp';

const backgroundImage =imgHero;
 
const styles = theme => ({
  background: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundColor: '#7fc7d9', // Average color of the background image.
    backgroundPosition: 'center',
    height: 'auto'
  },
  button: {
    minWidth: 200,
  },
  h5: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10),
    },
  },
  more: {
    marginTop: theme.spacing(2),
  },
  
  
});

function ProductHero(props) {
  const { classes } = props;

  return (
    <ProductHeroLayout backgroundClassName={classes.background}>
      {/* Increase the network loading priority of the background image. */}
      <img style={{ display: 'none' }} src={backgroundImage} alt="increase priority" />
      
      <Typography classes={classes.typography} fontFamily = 'Kalam' color="inherit" align="center" variant="h2" marked="center">
        {/*"El costo de equivocarse es menor que el costo de no hacer nada"*/}
        "El negocio puede ser pequeño, pero la visión tiene que ser grande."
      </Typography>
      <Typography color="inherit" align="center" variant="h5" marked="center">
        Anónimo
      </Typography>
      
     
    </ProductHeroLayout>
  );
}

ProductHero.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHero);
